// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__dIJlT","btnOffer":"AddProduct_btnOffer__H-Iey"};